import { z } from "zod";
import {
  DesignTokenTypedData,
  DesignTokenType,
  ThemeOriginObject,
  ThemeOriginSource,
  ThemeOverrideOrigin,
  ThemeOverrideOriginPart,
} from "../elements";
import { ObjectMeta } from "../../common";

//
// Overrides
//

export const ThemeOverrideImportModelBase = DesignTokenTypedData.and(
  z.object({
    id: z.string(),
    meta: ObjectMeta,
  })
);

export const ThemeOverrideImportModel = ThemeOverrideImportModelBase.and(
  z.object({
    origin: ThemeOverrideOrigin,
  })
);

export const ThemeOverrideImportModelInput = ThemeOverrideImportModelBase.and(
  z.object({
    originId: z.string(),
    originMetadata: ThemeOverrideOriginPart,
  })
);

export type ThemeOverrideImportModel = z.infer<typeof ThemeOverrideImportModel>;
export type ThemeOverrideImportModelOfType<T extends DesignTokenType> = Extract<ThemeOverrideImportModel, { type: T }>;

export type ThemeOverrideImportModelInput = z.infer<typeof ThemeOverrideImportModelInput>;
export type ThemeOverrideImportModelInputOfType<T extends DesignTokenType> = Extract<
  ThemeOverrideImportModelInput,
  { type: T }
>;

//
// Themes
//

export const ThemeImportModel = z.object({
  meta: ObjectMeta,
  brandPersistentId: z.string(),
  originSource: ThemeOriginSource,
  overrides: z.array(ThemeOverrideImportModel),
  sortOrder: z.number(),
});

export const ThemeImportModelInput = z.object({
  meta: ObjectMeta,
  originObjects: z.array(ThemeOriginObject),
  overrides: z.array(ThemeOverrideImportModelInput),
});

export type ThemeImportModel = z.infer<typeof ThemeImportModel>;
export type ThemeImportModelInput = z.infer<typeof ThemeImportModelInput>;

//
// Theme Update
//

export const ThemeUpdateImportModel = z.object({
  themePersistentId: z.string(),
  overrides: z.array(ThemeOverrideImportModel),
});

export const ThemeUpdateImportModelInput = z.object({
  themePersistentId: z.string(),
  overrides: z.array(ThemeOverrideImportModelInput),
});

export type ThemeUpdateImportModel = z.infer<typeof ThemeUpdateImportModel>;
export type ThemeUpdateImportModelInput = z.infer<typeof ThemeUpdateImportModelInput>;
